import { CSSProperties } from 'react'

import {
  StyledContainer,
  StyledLeftContainer,
  StyledBorderContainer,
  StyledOneColumnContainer,
} from './index.styled'

export type Props = {
  leftColumn?: JSX.Element
  rightColumn?: JSX.Element
  isHavingBorder?: boolean
  className?: string
  leftStyle?: CSSProperties
  rightStyle?: CSSProperties
}

const TwoColumnsContainer = ({
  className,
  leftColumn,
  rightColumn,
  isHavingBorder = true,
  leftStyle,
  rightStyle,
}: Props) => {
  return rightColumn && leftColumn ? (
    <StyledContainer className={className}>
      <StyledLeftContainer style={leftStyle}>{leftColumn}</StyledLeftContainer>
      <StyledBorderContainer data-border={isHavingBorder} style={rightStyle}>
        {rightColumn}
      </StyledBorderContainer>
    </StyledContainer>
  ) : (
    <StyledOneColumnContainer>
      {rightColumn || leftColumn || <></>}
    </StyledOneColumnContainer>
  )
}

export { TwoColumnsContainer }
